import { useMemo } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import EditorToolbar from "./EditorToolbar";
import { twMerge } from "tailwind-merge";

export const Editor = props => {
    const style = twMerge("h-[calc(100%-44px)]", props.className);
    const modules = useMemo(() => {
        return {
            toolbar: {
                container: "#toolbar",
            },
            history: {
                delay: 500,
                maxStack: 100,
                userOnly: true,
            },
            ImageResize: {
                parchment: Quill.import("parchment"),
            },
        };
    }, []);

    const formats = [
        "header",
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "align",
        "strike",
        "script",
        "blockquote",
        "background",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "color",
    ];

    return (
        <>
            <EditorToolbar onClickRaw={props.onClickRaw} btnHtmlOn={props.btnHtmlOn} showBtnHtml={props.showBtnHtml} />
            <ReactQuill
                theme="snow"
                value={props.value}
                onChange={props.onChangeHandler}
                // placeholder={"Write something awesome..."}
                modules={modules}
                formats={formats}
                className={style}
                bounds={props.bounds}
            />
        </>
    );
};

export default Editor;
